export default "__VITE_ASSET__CMlxOsQZ__"